<template>
  <v-tooltip bottom max-width="262">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="!comparing"
        v-on="on"
        outlined
        class="bordered-button"
        small
        data-tourid="insights-widget-compare-button"
        :loading="loading"
        :ripple="false"
        :disabled="disabled"
        @click="handleCompareChange(!comparing)"
      >
        <div class="d-flex">
          <v-icon size="16" class="me-1" color="blue-grey darken-1"
            >mdi-earth</v-icon
          >
          <p class="ma-0 pa-0 blue-grey--text text--darken-1 caption">
            {{ $t('insights.compare') }}
          </p>
        </div>
      </v-btn>
      <v-btn
        v-else
        v-on="on"
        small
        class="active-bordered-button"
        data-tourid="insights-widget-compare-button"
        :loading="loading"
        :ripple="false"
        :disabled="disabled"
        @click="handleCompareChange(!comparing)"
      >
        <div class="d-flex">
          <v-icon size="16" class="me-1" color="blue-grey darken-1"
            >mdi-earth</v-icon
          >
          <p class="ma-0 pa-0 blue-grey--text text--darken-1 caption">
            {{ $t('insights.compare') }}
          </p>
        </div>
      </v-btn>
    </template>
    {{ $t('insights.compare_tooltip') }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'CompareButton',

  props: {
    loading: Boolean,
    disabled: Boolean,
    comparing: Boolean,
  },

  methods: {
    handleCompareChange(comparing) {
      this.$emit('click', comparing)
    },
  },
}
</script>

<style lang="scss">
.insight-card {
  .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: inherit !important;
    .v-btn__loader {
      .v-progress-circular {
        height: 16px !important;
        width: 16px !important;
        color: $color-blue-grey-darken1 !important;
      }
    }
  }

  .v-btn__loader {
    .v-progress-circular {
      height: 16px !important;
      width: 16px !important;
      color: $color-blue-grey-darken1 !important;
    }
  }

  .v-btn.v-size--small {
    padding: 4px 8px;
  }

  .v-btn__content {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .bordered-button {
    border-radius: 4px !important;
    border: 1px solid $color-blue-grey-lighten2 !important;
    &:hover {
      background-color: $color-blue-grey-lighten3 !important;
    }
  }

  .active-bordered-button {
    border-radius: 4px !important;
    border: 1px solid $color-blue-grey-lighten2 !important;
    background-color: $color-blue-grey-lighten3 !important;
    &:hover {
      background-color: $color-blue-grey-lighten3 !important;
    }
  }

  .bordered-button.v-btn::before {
    background-color: $color-blue-grey-lighten3 !important;
  }

  .active-bordered-button.v-btn::before {
    background-color: $color-blue-grey-lighten3 !important;
  }
}
</style>
